import $ from 'jquery'

import "../sass/app.scss";



import masonry from "masonry-layout";
import lazysizes from "lazysizes";

// require('masonry-layout');
// require('lazysizes');


   //add simple support for background images lazy loadin:
         document.addEventListener("lazybeforeunveil", function (e) {
             var bg = e.target.getAttribute("data-background-image");
             if (bg) {
                 e.target.style.backgroundImage = "url(" + bg + ")";
             }
         });


 (function ($) {

     document.addEventListener("DOMContentLoaded", function () {
     
      

         // open menu mobile
         $(".menu-toggle").click(function () {
             $(".primary-navigation").slideToggle();
         });

         // MENU RESPONSIVE open submenu
         $(".menu-item-has-children > a").append(
             "<span class='open_sub_menu'> + </span>"
         );
         $(".header .open_sub_menu").on("click", function (e) {
             e.preventDefault();
             var $this = $(this).parent().toggleClass("menu-opened");

             var mainmenu = $this.next(".sub-menu");
             console.log(mainmenu);
             if (mainmenu.hasClass("open")) {
                 mainmenu.slideToggle().removeClass("open");
             } else {
                 mainmenu.slideToggle().addClass("open");
                 mainmenu.show();
             }
         });

         var resizeFix = function () {
             var mediasize = 1200;
             if ($(window).width() > mediasize) {
                 $(".sub-menu").removeAttr("style").removeClass("open");
             }
         };
         resizeFix();

             //custom select
             $("select").select2({
                 selectOnClose: true,
                 theme: "classic",
             });
      

         // auto load date in calendar
         var $form = $(".wc-bookings-booking-form");
         if ($(".hide_calendar_booking").length != 0) {
             $form.find(".booking_date_day").val($d);
             $form.find(".booking_date_month").val($m);
             $form.find(".booking_date_year").val($y);
         }

         /*global storefront_sticky_add_to_cart_params */
         // function qui s'invoque directement
         ( function() {
          var stickyAddToCart = document.getElementsByClassName(
              "storefront-sticky-add-to-cart"
          );

          if (!stickyAddToCart.length) {
              return;
          }

          if (typeof storefront_sticky_add_to_cart_params === "undefined") {
              return;
          }

          var trigger = document.getElementsByClassName(
              storefront_sticky_add_to_cart_params.trigger_class
          );

          if (trigger.length > 0) {
              var stickyAddToCartToggle = function () {
                  if (
                      trigger[0].getBoundingClientRect().top +
                          trigger[0].scrollHeight <
                      0
                  ) {
                      stickyAddToCart[0].classList.add(
                          "storefront-sticky-add-to-cart--slideInDown"
                      );
                      stickyAddToCart[0].classList.remove(
                          "storefront-sticky-add-to-cart--slideOutUp"
                      );
                  } else if (
                      stickyAddToCart[0].classList.contains(
                          "storefront-sticky-add-to-cart--slideInDown"
                      )
                  ) {
                      stickyAddToCart[0].classList.add(
                          "storefront-sticky-add-to-cart--slideOutUp"
                      );
                      stickyAddToCart[0].classList.remove(
                          "storefront-sticky-add-to-cart--slideInDown"
                      );
                  }
              };

              stickyAddToCartToggle();

              window.addEventListener("scroll", function () {
                  stickyAddToCartToggle();
              });

              // Get product id
              var product_id = null;

              document.body.classList.forEach(function (item) {
                  if ("postid-" === item.substring(0, 7)) {
                      product_id = item.replace(/[^0-9]/g, "");
                  }
              });

              if (product_id) {
                  var product = document.getElementById("product-" + product_id);

                  if (product) {
                      if (
                          !product.classList.contains("product-type-simple") &&
                          !product.classList.contains("product-type-external")
                      ) {
                          var selectOptions = document.getElementsByClassName(
                              "storefront-sticky-add-to-cart__content-button"
                          );

                          selectOptions[0].addEventListener(
                              "click",
                              function (event) {
                                  event.preventDefault();
                                  document
                                      .getElementById("product-" + product_id)
                                      .scrollIntoView();
                              }
                          );
                      }
                  }
              }
          }
         } )();



    

         var windowHeight = $(window).height();
         var imgHeight = windowHeight - windowHeight * 0.25;
         var headerHeight = $(".header").outerHeight(true);

         $(".headerImg-content").css("padding-top", headerHeight + 80);
         $(".headerImg .bg-img").css("height", imgHeight);

         function headerImgFullHeight() {
             var windowHeight = $(window).height();
             var imgHeight = windowHeight - windowHeight * 0.25; // window height less big
             var headerContentHeight =
                 $(".headerImg-content").outerHeight(true);
             var headerHeight = $(".header").outerHeight(true);
             // console.log( imgHeight + ' <= ' + headerContentHeight);

             if (imgHeight <= headerContentHeight) {
                 $(".headerImg .bg-img").css("height", headerContentHeight);
             } else {
                 $(".headerImg .bg-img").css("height", imgHeight);
             }
         }

         $(".slick-slider-header").on("init", function (event, slick) {
             headerImgFullHeight();
         });

         $(".slick-slider-header").slick({
             slidesToShow: 1,
             arrows: false,
             dots: true,
             infinite: false,
             autoplay: true,
             autoplaySpeed: 2000,
             pauseOnHover: true,
             pauseOnDotsHover: true,
         });

         $(window).resize(function () {
             resizeFix();
             headerImgFullHeight();
         });

         $(window).load(function () {
             headerImgFullHeight();
         });

       

         $(".slick-slider-alternated").slick({
             slidesToShow: 1,
             arrows: false,
             dots: true,
             infinite: false,
             autoplay: true,
             autoplaySpeed: 2000,
             pauseOnHover: true,
             pauseOnDotsHover: true,
         });

         $(".slick-slider-simplePage").slick({
             slidesToShow: 1,
             arrows: false,
             dots: true,
             lazyLoad: "progressive",
             autoplay: true,
             autoplaySpeed: 2000,
             pauseOnHover: true,
             pauseOnDotsHover: true,
         });

         //slider page restaurant
         $(".slick-slider-singleRestaurant").slick({
             slidesToShow: 1,
             arrows: false,
             dots: true,
             autoplay: true,
             autoplaySpeed: 2000,
             pauseOnHover: true,
             pauseOnDotsHover: true,
         });



 $(".slick-slider-logo").slick({
             slidesToShow: 6,
             slidesToScroll: 6,
             arrows: false,
             dots: true,
             infinite: true,
             autoplay: true,
             autoplaySpeed: 2000,
             lazyLoad: "progressive",
             pauseOnHover: true,
             pauseOnDotsHover: true,
             responsive: [
                 {
                     breakpoint: 1024,
                     settings: {
                         slidesToShow: 3,
                         slidesToScroll: 3,
                     },
                 },
                 {
                     breakpoint: 600,
                     settings: {
                         slidesToShow: 2,
                         slidesToScroll: 2,
                     },
                 },
                 {
                     breakpoint: 480,
                     settings: {
                         slidesToShow: 1,
                         slidesToScroll: 1,
                         dots: false,
                     },
                 },
                 // You can unslick at a given breakpoint now by adding:
                 // settings: "unslick"
                 // instead of a settings object
             ],
         });

         // slider de témoignage
         $(".slick-slider-testimonial").slick({
             slidesToShow: 3,
             slidesToScroll: 3,
             arrows: false,
             dots: true,
             infinite: true,
             autoplay: true,
             autoplaySpeed: 2000,
             pauseOnHover: true,
             pauseOnDotsHover: true,
             responsive: [
                 {
                     breakpoint: 992,
                     settings: {
                         slidesToShow: 2,
                         slidesToScroll: 2,
                     },
                 },
                 {
                     breakpoint: 601,
                     settings: {
                         slidesToShow: 1,
                         slidesToScroll: 1,
                     },
                 },
             ],
         });

         // ------------------------------------------------------
         // NEWSLETTER FROM MUTLTI SELECT
         // ------------------------------------------------------S

         $(".sib-multi-lists-area label").click(function (event) {
             event.stopPropagation();
             $("label").toggleClass("open");
             $(".sib-multi-lists").slideToggle();
         });

         $(".sib-multi-lists input").click(function () {
             $(this).parent().toggleClass("checked");
         });

         //close dropdown if click outside
         $(document).click(function (e) {
             if ($(e.target).closest(".sib-multi-lists-area").length === 0) {
                 $("label").removeClass("open");
                 $(".sib-multi-lists").slideUp();
             } else {
                 e.stopPropagation();
             }
         });
         // ------------------------------------------------------

         //---------------------------//
         // ===== Scroll to Top ====
         //---------------------------//

         $(window).scroll(function () {
             if ($(this).scrollTop() >= 400) {
                 // If page is scrolled more than 400
                 $("#return-to-top").fadeIn(200); // Fade in the arrow
             } else {
                 $("#return-to-top").fadeOut(200); // Else fade out the arrow
             }
         });

         $("#return-to-top").click(function () {
             // When arrow is clicked
             $("body,html").animate(
                 {
                     scrollTop: 0, // Scroll to top of body
                 },
                 500
             );
         });

         //Scroll page button to a specific div with smooth scroll
         var offsetSize = 20; //$(".fixed-header").innerHeight();
         $("a[href*=\\#]").on("click", function (e) {
             // Au clic sur un élément
             var target = this.hash;
             var $target = $(target);
             var targetname = target.slice(1, target.length);
             if (document.getElementById(targetname) != null) {
                 //if element is present in page
                 e.preventDefault();
                 $("html, body")
                     .stop()
                     .animate(
                         {
                             scrollTop: $target.offset().top - offsetSize, //or the height of your fixed navigation
                         },
                         900
                     );
             }
         });
         //scroll page anchor in other page

         if (window.location.hash.length !== 0) {
             $("html, body").animate(
                 {
                     scrollTop:
                         $(window.location.hash).offset().top - offsetSize,
                 },
                 750
             );
         }

         // Détection du support
         if (typeof sessionStorage != "undefined") {
             if ("popin" in sessionStorage) {
                 // if key popin in sesssion storage exist
                 var popin = sessionStorage.getItem("popin"); // get value in session storage
                 if (popin == "notShow") {
                     //test value, if, false, display the popin
                     // display popup
                     popUp();
                 }
             } else {
                 // if key popin in sesssion storage does't existe we set the value to false
                 sessionStorage.setItem("popin", "alreadyShow");
                 popUp();
             }
         } else {
             console.log("sessionStorage n'est pas supporté");
         }

         // display Newsletter
         function popUp() {
             var popup = $(".popUpInfo").not("#booking_popup");
             if (popup.length == 1) {
                 setTimeout(function () {
                     popup.addClass("showUp");
                 }, 2000);

                 $(".popUpInfo #close_popup").click(function () {
                     popup.removeClass("showUp");
                     // Enregistrer des données dans sessionStorage
                     sessionStorage.setItem("popin", "alreadyShow");
                 });
             }
         }

       
       
       
       
function initMap() {
    // ------------------------------------------------------
    // MAP
    // ------------------------------------------------------

    /*
     *  document ready
     *
     *  This function will render each map when the document is ready (page has loaded)
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 5.0.0
     *
     *  @param n/a
     *  @return  n/a
     */
    // global var
    var map = null;

    $(document).ready(function () {
        $(".google-maps").each(function () {
            // create map

            map = new_map($(this));
        });
    });

    /*
     *  new_map
     *
     *  This function will render a Google Map onto the selected jQuery element
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param $el (jQuery element)
     *  @return  n/a
     */

    function new_map($el) {
        // var
        var $markers = $el.find(".marker");

        // vars
        var args = {
            zoom: 13, // on the bottom there is also a zoom
            disableDefaultUI: false,
            center: new google.maps.LatLng(0, 0),
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            styles: [
                {
                    stylers: [
                        {
                            saturation: -100,
                        },
                        {
                            gamma: 1,
                        },
                    ],
                },
                {
                    elementType: "labels.text.stroke",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "poi.business",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "poi.business",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "poi.place_of_worship",
                    elementType: "labels.text",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "poi.place_of_worship",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            visibility: "off",
                        },
                    ],
                },
                {
                    featureType: "road",
                    elementType: "geometry",
                    stylers: [
                        {
                            visibility: "simplified",
                        },
                    ],
                },
                {
                    featureType: "water",
                    stylers: [
                        {
                            visibility: "on",
                        },
                        {
                            saturation: 50,
                        },
                        {
                            gamma: 0,
                        },
                        {
                            hue: "#50a5d1",
                        },
                    ],
                },
                {
                    featureType: "administrative.neighborhood",
                    elementType: "labels.text.fill",
                    stylers: [
                        {
                            color: "#333333",
                        },
                    ],
                },
                {
                    featureType: "road.local",
                    elementType: "labels.text",
                    stylers: [
                        {
                            weight: 0.5,
                        },
                        {
                            color: "#333333",
                        },
                    ],
                },
                {
                    featureType: "transit.station",
                    elementType: "labels.icon",
                    stylers: [
                        {
                            gamma: 1,
                        },
                        {
                            saturation: 50,
                        },
                    ],
                },
            ],
        };

        // create map
        var map = new google.maps.Map($el[0], args);

        // add a markers reference
        map.markers = [];

        // add markers
        $markers.each(function () {
            add_marker($(this), map);
        });

        // center map
        center_map(map);

        // return
        return map;
    }

    /*
     *  add_marker
     *
     *  This function will add a marker to the selected Google Map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param $marker (jQuery element)
     *  @param map (Google Map object)
     *  @return  n/a
     */

    function add_marker($marker, map) {
        // var
        var latlng = new google.maps.LatLng(
            $marker.attr("data-lat"),
            $marker.attr("data-lng")
        );

        // create marker
        var marker = new google.maps.Marker({
            position: latlng,
            map: map,
        });

        // add to array
        map.markers.push(marker);

        // if marker contains HTML, add it to an infoWindow
        if ($marker.html()) {
            // create info window
            var infowindow = new google.maps.InfoWindow({
                content: $marker.html(),
            });

            //custom option infowindow
            var ibOptions = {
                disableAutoPan: false,
                maxWidth: 0,
                pixelOffset: new google.maps.Size(-140, 0),
                zIndex: null,
                boxStyle: {
                    padding: "0px 0px 0px 0px",
                    width: "252px",
                    height: "40px",
                },
                closeBoxURL: "",
                infoBoxClearance: new google.maps.Size(1, 1),
                isHidden: false,
                pane: "floatPane",
                enableEventPropagation: false,
            };

            // show info window when marker is clicked
            google.maps.event.addListener(marker, "click", function () {
                infowindow.open(map, marker);
            });

            // Event that closes the Info Window with a click on the map
            google.maps.event.addListener(map, "click", function () {
                infowindow.close();
            });
        }
    }

    /*
     *  center_map
     *
     *  This function will center the map, showing all markers attached to this map
     *
     *  @type  function
     *  @date  8/11/2013
     *  @since 4.3.0
     *
     *  @param map (Google Map object)
     *  @return  n/a
     */

    function center_map(map) {
        // vars
        var bounds = new google.maps.LatLngBounds();

        // loop through all markers and create bounds
        $.each(map.markers, function (i, marker) {
            var latlng = new google.maps.LatLng(
                marker.position.lat(),
                marker.position.lng()
            );

            bounds.extend(latlng);
        });

        // only 1 marker?
        if (map.markers.length == 1) {
            // set center of map
            map.setCenter(bounds.getCenter());
            map.setZoom(13);
        } else {
            // fit to bounds

            map.fitBounds(bounds);
        }
    }
}
        
window.initMap = initMap;
         
     });
 })(jQuery);
